import { Injectable } from '@angular/core';
import type { Params } from '@angular/router';
import { BehaviorSubject, firstValueFrom, type Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavigationContext {
  // until we set this the app root is assumed to be the default
  private readonly urlSubject$ = new BehaviorSubject<string>('/');
  private readonly urlParamsSubject$ = new BehaviorSubject<Params | null>({});
  private readonly queryParamsSubject$ = new BehaviorSubject<Params | null>({});

  // Note: These should only be necessary for services not loaded into a router outlet
  // since they will not receive the ActivatedRoute information.
  getUrlParams$(): Observable<Params | null> {
    return this.urlParamsSubject$.asObservable();
  }

  getQueryParams$(): Observable<Params | null> {
    return this.queryParamsSubject$.asObservable();
  }

  getUrl$(): Observable<string> {
    return this.urlSubject$.asObservable();
  }

  getUrlParams(): Params | null {
    return this.urlParamsSubject$.getValue();
  }

  getQueryParams(): Params | null {
    return this.queryParamsSubject$.getValue();
  }

  getUrl(): string {
    return this.urlSubject$.getValue();
  }

  setUrlParams(urlParams: Params | null): void {
    this.urlParamsSubject$.next(urlParams);
  }

  setQueryParams(queryParams: Params | null): void {
    this.queryParamsSubject$.next(queryParams);
  }

  async setUrl(url: string): Promise<void> {
    const prevUrl: string = await firstValueFrom(this.urlSubject$);
    if (prevUrl !== url) {
      this.urlSubject$.next(url);
    }
  }
}
